import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MergeReapprovalRegulatoryDocumentChangesMutationVariables = Types.Exact<{
  input: Types.MergeReapprovalRegulatoryDocumentChangesInput;
}>;


export type MergeReapprovalRegulatoryDocumentChangesMutation = { __typename?: 'Mutation', mergeReapprovalRegulatoryDocumentChanges: { __typename?: 'MergeReapprovalRegulatoryDocumentChangesPayload', boolean?: boolean | null } };


export const MergeReapprovalRegulatoryDocumentChangesDocument = gql`
    mutation MergeReapprovalRegulatoryDocumentChanges($input: MergeReapprovalRegulatoryDocumentChangesInput!) {
  mergeReapprovalRegulatoryDocumentChanges(input: $input) {
    boolean
  }
}
    `;
export type MergeReapprovalRegulatoryDocumentChangesMutationFn = Apollo.MutationFunction<MergeReapprovalRegulatoryDocumentChangesMutation, MergeReapprovalRegulatoryDocumentChangesMutationVariables>;

/**
 * __useMergeReapprovalRegulatoryDocumentChangesMutation__
 *
 * To run a mutation, you first call `useMergeReapprovalRegulatoryDocumentChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeReapprovalRegulatoryDocumentChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeReapprovalRegulatoryDocumentChangesMutation, { data, loading, error }] = useMergeReapprovalRegulatoryDocumentChangesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeReapprovalRegulatoryDocumentChangesMutation(baseOptions?: Apollo.MutationHookOptions<MergeReapprovalRegulatoryDocumentChangesMutation, MergeReapprovalRegulatoryDocumentChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeReapprovalRegulatoryDocumentChangesMutation, MergeReapprovalRegulatoryDocumentChangesMutationVariables>(MergeReapprovalRegulatoryDocumentChangesDocument, options);
      }
export type MergeReapprovalRegulatoryDocumentChangesMutationHookResult = ReturnType<typeof useMergeReapprovalRegulatoryDocumentChangesMutation>;
export type MergeReapprovalRegulatoryDocumentChangesMutationResult = Apollo.MutationResult<MergeReapprovalRegulatoryDocumentChangesMutation>;
export type MergeReapprovalRegulatoryDocumentChangesMutationOptions = Apollo.BaseMutationOptions<MergeReapprovalRegulatoryDocumentChangesMutation, MergeReapprovalRegulatoryDocumentChangesMutationVariables>;